<template>
    <div>
        <div class="order__chekboxs">
            <div v-for="item in tabs" :key="item.tab" :class="{ order__chekbox: true, 'chekbox-order': true, active: activeTab === item.tab }" @click="selectOption(item.tab)">
                <div class="chekbox-order__top">
                    <img :src="item.image" style="max-width: 56px" alt="" />
                </div>
                <div class="chekbox-order__text" v-html="item.text"></div>
            </div>
        </div>
    </div>
    <div data-tabs-body class="tabs-order__content">
        <div class="tabs-order__body" v-show="activeTab === 'tab1'">
            <div class="city-select">
                <!-- Выбор города -->
                <v-select class="form form-v-select form-v-select-np" v-model="selectedCity" :options="cities" @search="fetchCities" size="10" label="Present" placeholder="Оберіть місто">
                    <template #no-options>
                        <div class="no-options">Введіть місто для пошуку</div>
                    </template>
                </v-select>
                <input type="text" class="input form-hidden-field" style="hidden: 0; height: 0; padding: 0; margin: 0; border: none" id="city" v-model="cityRef" name="city" :required="activeTab == 'tab1'" readonly />
                <input type="text" class="input form-hidden-field" id="city_name" v-model="cityName" name="city_name" placeholder="Оберіть місто" @click="showDeliveryCityPopup = true" readonly />
            </div>

            <div class="city-select">
                <!-- Выбор отделения -->
                <v-select class="form form-v-select form-v-select-np" name="department" v-model="selectedDepartment" :options="departments" @search="fetchDepartments" @open="handleDepartmentOpen" label="Description" placeholder="Оберіть відділення або поштомат">
                    <template #no-options>
                        <div class="no-options">Введіть адресу або номер відділення для пошуку</div>
                    </template></v-select
                >
                <input type="text" class="input form-hidden-field" style="hidden: 0; height: 0; padding: 0; margin: 0; border: none" v-model="cityDepartamentRef" name="department" :required="activeTab == 'tab1'" readonly />
                <input type="text" class="input form-hidden-field" v-model="cityDepartamentName" name="department_name" placeholder="Оберіть відділення або поштомат" @click="showDeliveryDepartamentPopup = true" readonly />
            </div>
        </div>
        <div class="tabs-order__body" v-show="activeTab === 'tab3'">
            <div class="order__col">
                <div class="order__row">
                    <input :required="activeTab === 'tab3'" v-model="expressDeliveryCity" autocomplete="off" type="text" name="express_delivery_city" placeholder="Місто" class="input" />
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab3'" v-model="expressDeliveryAddress" autocomplete="off" type="text" name="express_delivery_address" placeholder="Адреса" class="input" />
                </div>
            </div>
        </div>
        <div class="tabs-order__body" v-show="activeTab === 'tab4'">
            <div class="order__col">
                <div class="order__row">
                    <div>
                        <span>{{ firstName }}</span>
                        <span style="margin: 0 2px"></span>
                        <span>{{ lastName }}</span>
                    </div>
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab4'" v-model="fieldsurname" class="input" name="surname" type="text" placeholder="По-батькові *" />
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab4'" v-model="urkposhtaDeliveryCities" autocomplete="off" type="text" name="urkposhta_delivery_cities" placeholder="Місто *" class="input" />
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab4'" v-model="urkposhtaDeliveryIndex" autocomplete="off" type="text" name="urkposhta_delivery_index" placeholder="Поштовий індекс *" class="input" />
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab4'" v-model="urkposhtaDeliveryDepartment" autocomplete="off" type="text" name="urkposhta_delivery_department" placeholder="Адреса *" class="input" />
                </div>
            </div>
        </div>
        <div class="tabs-order__body" v-show="activeTab === 'tab5'">
            <div class="order__col">
                <div class="order__row">
                    <div>
                        <span>{{ firstName }}</span>
                        <span style="margin: 0 2px"></span>
                        <span>{{ lastName }}</span>
                    </div>
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab5'" v-model="fieldsurname" class="input" name="surname" type="text" placeholder="По-батькові *" />
                </div>
                <div class="order__row">
                    <!-- <input :required="activeTab === 'tab5'" v-model="internationalDeliveryCities" autocomplete="off" type="text" name="international_delivery_counry" placeholder="Країна *" class="input" /> -->
                    <v-select :required="activeTab === 'tab5'" class="form form-v-select input" name="department" v-model="selectedCounty" :options="countryOptions" label="Description" placeholder="Країна *">
                        <template #no-options>
                            <div class="no-options">Оберіть країну доставки</div>
                        </template></v-select
                    >
                    <input type="text" class="input form-hidden-field" id="country" v-model="countryName" name="country" placeholder="Оберіть країну *" @click="showInternationalDelivery = true" :required="activeTab == 'tab5'" readonly />
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab5'" v-model="internationalDeliveryCities" autocomplete="off" type="text" name="international_delivery_cities" placeholder="Місто *" class="input" />
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab5'" v-model="internationalDeliveryIndex" autocomplete="off" type="text" name="international_delivery_index" placeholder="Поштовий індекс *" class="input" />
                </div>
                <div class="order__row">
                    <input :required="activeTab === 'tab5'" v-model="internationalDeliveryDepartment" autocomplete="off" type="text" name="international_delivery_department" placeholder="Адреса *" class="input" />
                </div>
            </div>
        </div>
    </div>
    <div class="delivery-popup" v-show="showDeliveryCityPopup">
        <div class="delivery-popup-bg" @click="showDeliveryCityPopup = false"></div>
        <div class="delivery-popup__wrapper">
            <input class="input delivery-popup__wrapper-input" type="text" placeholder="Пошук" v-model="selectedCityMob" :options="cities" @input="fetchCitiesMob('input')" />

            <ul class="delivery-popup__list">
                <li v-for="city in cities" :key="city.id" :data-name="city.Present" :data-ref="city.DeliveryCity" @click="handleCitySelect(city)">
                    {{ city.Present }}
                </li>
            </ul>
        </div>
    </div>
    <div class="delivery-popup" v-show="showDeliveryDepartamentPopup">
        <div class="delivery-popup-bg" @click="showDeliveryDepartamentPopup = false"></div>
        <div class="delivery-popup__wrapper">
            <input class="input delivery-popup__wrapper-input" type="text" placeholder="Пошук" v-model="selectedDepartmentMob" :options="cities" @input="fetchDepartmentsMob()" />

            <ul class="delivery-popup__list">
                <li v-for="department in departments" :key="department.id" :data-name="department.Description" :data-ref="department.Ref" @click="handleCityDepartamentSelect(department)">
                    {{ department.Description }}
                </li>
            </ul>
        </div>
    </div>
    <div class="delivery-popup" v-show="showInternationalDelivery">
        <div class="delivery-popup-bg" @click="showInternationalDelivery = false"></div>
        <div class="delivery-popup__wrapper">
            <input class="input delivery-popup__wrapper-input" type="text" placeholder="Пошук" v-model="searchQueryCounty" />

            <ul class="delivery-popup__list">
                <li v-for="country in filterCountries" :key="country" @click="handleCountySelect(country)">
                    {{ country }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
const emit = defineEmits(["delivery-data"]);
import { ref, watch, onMounted, computed } from "vue";
import vSelect from "vue-select";
import countries from "@/assets/countries.json";

const props = defineProps({
    firstName: String,
    lastName: String,
});

const config = useRuntimeConfig();
const apiUrl = config.public.apiUrl; // Access the apiUrl
const selectedCity = ref("");
const selectedCityMob = ref("");
const cityName = ref("");
const cityRef = ref("");
const cityDepartamentName = ref("");
const cityDepartamentRef = ref("");
const selectedCityOption = ref("");
const selectedCitRefOption = ref("");
const selectedDepartment = ref(null);
const selectedDepartmentMob = ref(null);
const selectedCounty = ref("");
const cities = ref([]);
const departments = ref([]);
const activeTab = ref("tab1");
const tabs = [
    { tab: "tab1", text: "Нова пошта", image: new URL("../assets/img/order/novaposhta.svg", import.meta.url).href },
    { tab: "tab3", text: "Кур'єр<br> нової пошти", image: new URL("../assets/img/order/02.svg", import.meta.url).href },
    { tab: "tab4", text: "Укр Пошта", image: new URL("../assets/img/order/ukrpochta.svg", import.meta.url).href },
    { tab: "tab5", text: "Міжнародна <br>доставка", image: new URL("../assets/img/order/international_delivery.svg", import.meta.url).href },
];
const expressDeliveryCity = ref("");
const expressDeliveryAddress = ref("");
const urkposhtaDeliveryCities = ref("");
const urkposhtaDeliveryIndex = ref("");
const urkposhtaDeliveryDepartment = ref("");
const fieldsurname = ref("");
const showDeliveryCityPopup = ref(false);
const showDeliveryDepartamentPopup = ref(false);
const showInternationalDelivery = ref(false);
const countryOptions = ref(countries);
const searchQueryCounty = ref("");
const internationalCountryName = ref("");
const internationalDeliveryCities = ref("");
const internationalDeliveryIndex = ref("");
const internationalDeliveryDepartment = ref("");

const fetchCities = async (search) => {
    if (search.length > 0) {
        const response = await $fetch(`${apiUrl}np/cities/${search}`);
        console.log(response);
        if (response.success) {
            cities.value = response.result[0].Addresses;
        }
    }
};

const fetchCitiesMob = async () => {
    const search = selectedCityMob.value ? selectedCityMob.value : "м. ";
    const response = await $fetch(`${apiUrl}np/cities/${search}`);
    if (response.success) {
        cities.value = response.result[0].Addresses;
    }
};

const fetchDepartments = async (search = "") => {
    // Проверяем наличие выбранного города (как для десктопа, так и для мобильных)
    const cityRefValue = selectedCity.value?.DeliveryCity || cityRef.value;
    if (cityRefValue) {
        // Используем search, если он предоставлен, иначе пустую строку
        const searchQuery = search || "";
        try {
            const response = await $fetch(`${apiUrl}np/warehouses/${cityRefValue}?search=${searchQuery}`);
            departments.value = response;
        } catch (error) {
            console.error("Error fetching departments:", error);
            departments.value = []; // Очищаем список в случае ошибки
        }
    } else {
        // Если город не выбран, очищаем список отделений
        departments.value = [];
    }
};

const fetchDepartmentsMob = async () => {
    if (cityRef.value) {
        const response = await $fetch(`${apiUrl}np/warehouses/${cityRef.value}?search=${selectedDepartmentMob.value}`);
        departments.value = response;
    }
};

const filterCountries = computed(() => {
    return countryOptions.value.filter((country) => country && typeof country === "string" && country.toLowerCase().includes(searchQueryCounty.value.toLowerCase()));
});

const selectOption = (tabName) => {
    activeTab.value = tabName;
};

const handleCitySelect = (city) => {
    selectedCityOption.value = city;
    if (city) {
        cityName.value = city.Present;
        cityRef.value = city.DeliveryCity;
    }
    fetchDepartmentsMob();
    showDeliveryCityPopup.value = false;
};

const handleCityDepartamentSelect = (department) => {
    selectedCitRefOption.value = department;
    if (department) {
        cityDepartamentName.value = department.Description;
        cityDepartamentRef.value = department.Ref;
    }
    showDeliveryDepartamentPopup.value = false;
};

const handleCountySelect = (country) => {
    countryName.value = country;
    internationalCountryName.value = country;
    showInternationalDelivery.value = false;
};

const handleDepartmentOpen = () => {
    // Загружаем список отделений при открытии, если он еще не загружен и город выбран
    const cityRefValue = selectedCity.value?.DeliveryCity || cityRef.value;
    if (cityRefValue && departments.value.length === 0) {
        fetchDepartments(); // Вызываем без аргумента search
    }
};

const emitDeliveryData = () => {
    const deliveryData = {
        activeTab: activeTab.value,
    };

    if (activeTab.value === "tab1") {
        deliveryData.selectedCity = selectedCity.value !== "" ? selectedCity.value : selectedCityOption.value;
        deliveryData.selectedDepartment = selectedDepartment.value !== null ? selectedDepartment.value : selectedCitRefOption.value;
    }

    if (activeTab.value === "tab3") {
        deliveryData.expressDeliveryCity = expressDeliveryCity.value;
        deliveryData.expressDeliveryAddress = expressDeliveryAddress.value;
    }

    if (activeTab.value === "tab4") {
        deliveryData.urkposhtaDeliveryCities = urkposhtaDeliveryCities.value;
        deliveryData.urkposhtaDeliveryIndex = urkposhtaDeliveryIndex.value;
        deliveryData.urkposhtaDeliveryDepartment = urkposhtaDeliveryDepartment.value;
        deliveryData.fieldsurname = fieldsurname.value;
    }

    if (activeTab.value === "tab5") {
        deliveryData.internationalCountryName = internationalCountryName.value;
        deliveryData.internationalDeliveryCities = internationalDeliveryCities.value;
        deliveryData.internationalDeliveryIndex = internationalDeliveryIndex.value;
        deliveryData.internationalDeliveryDepartment = internationalDeliveryDepartment.value;
        deliveryData.fieldsurname = fieldsurname.value;
    }

    emit("delivery-data", deliveryData);
};
watch([selectedCity, selectedDepartment, cityRef, cityDepartamentRef, fieldsurname, activeTab, expressDeliveryCity, expressDeliveryAddress, urkposhtaDeliveryCities, urkposhtaDeliveryIndex, urkposhtaDeliveryDepartment, selectedCounty, internationalCountryName, internationalDeliveryCities, internationalDeliveryIndex, internationalDeliveryDepartment], emitDeliveryData);

watch(selectedCity, (newCity) => {
    // При изменении города очищаем выбранное отделение и список отделений
    selectedDepartment.value = null;
    departments.value = [];
    // Очищаем также мобильные поля, если они используются
    selectedCitRefOption.value = null;
    cityDepartamentName.value = "";
    cityDepartamentRef.value = "";
    // Не вызываем fetchDepartments здесь, чтобы не загружать сразу,
    // а только при открытии или поиске во втором поле
});

onMounted(() => {
    fetchCitiesMob();
    emitDeliveryData();
});
</script>

<style>
@import "vue-select/dist/vue-select.css";
</style>

<style scoped>
.city-select {
    margin-bottom: 10px;
}
.city-select .vs__dropdown-toggle {
    color: inherit;
    text-align: center;
    background-color: #fff;
    cursor: pointer;
    width: 100%;
    border: 1px solid #aaa;
    border-radius: 5px;
}

.city-select ::v-deep .vs__search {
    width: 100%;
    background-color: transparent;
    height: 100%;
    margin: 0;
}

.city-select ::v-deep .vs__actions {
    padding-right: 15px;
}

.city-select ::v-deep .vs__selected-options {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    min-width: 0;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 3.0625rem;
    padding: 0 0.9375rem;
    gap: 0.625rem;
    font-weight: 500;
    line-height: 131.3%;
    color: rgba(0, 0, 0, 0.77);
}

.delivery-popup {
    /* background: rgba(0, 0, 0, 0.4); */
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 150;
    display: flex;
    flex-direction: column;
    justify-content: end;
}

.delivery-popup-bg {
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 150;
    display: flex;
    flex-direction: column;
    justify-content: end;
    z-index: 1;
}

.delivery-popup__wrapper {
    max-height: 384px;
    height: 100%;
    background: #fff;
    padding: 22px;
    z-index: 50;
    font-size: 14px;
    position: relative;
}
.delivery-popup__wrapper .input {
    border-radius: 6px !important;
    border-color: #00000030;
}

.delivery-popup__select {
    margin: 20px 0;
    width: 100%;
}

/* Для большинства браузеров */
.delivery-popup__select:focus {
    outline: none;
    border: none;
    box-shadow: none;
}

/* Для Firefox */
.delivery-popup__select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
}

.delivery-popup__wrapper-input {
    font-size: 16px;
}

@media (min-width: 768px) {
    .form-hidden-field {
        height: 1px !important;
        opacity: 0.1;
        padding: 0;
        border: none;
    }

    .city-select {
        display: grid;
        grid-template-columns: 2fr 1fr;
    }
}
@media (max-width: 768px) {
    .city-select ::v-deep .vs__selected-options {
        height: 2.8125rem;
    }

    .form-v-select {
        display: none;
    }
    .form-hidden-field {
        /* margin-bottom: 10px; */
    }

    .delivery-popup__list {
        margin: 20px 0;
        height: 80%;
        width: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;
        row-gap: 18px;
        font-size: 16px;
    }
}

.city-select ::v-deep .vs__selected {
    display: flex;
    height: 100%;
    align-items: center;
}

.form.form-v-select.input {
    padding: 0;
}
.form.form-v-select.input ::v-deep .vs__dropdown-toggle {
    height: 100% !important;
    padding-left: 20px;
}
</style>
